<template>
  <div class="rew19_aro_wrap shop four_plus_wrap">
    <div class="rew19_contents_inner rew19-contents-inner--wide">
      <h2 class="rew19-contents-title">4+1 정기구매 진행상세</h2>

      <div class="rew19_tabwrap">
        <ul class="rew19_linetab_pop nav nav-tabs nav-stacked">
            <li><router-link :to="{name:'fourPlusList'}">유지중인 4+1 정기구매</router-link></li>
            <li class="active"><a href="#">4+1 정기구매 History</a></li>
        </ul>
      </div>

      <div class="rew19_twoTable_wrap" v-for="retention in viewData.retentionList" :key="retention.index">
        <div class="rew19_title-withbtn">
          <em>[{{retention.aroNo}}] {{retention.title}}</em>
        </div>

        <swiper :options="swiperOption" ref="mySwiper" class="four_plus_swiper">
            <swiper-slide v-for="item in retention.yearList.slice().reverse()" :key="item.index">
            <table class="rew19-table-col pc">
                <caption>콜 테이블</caption>
                <colgroup>
                    <col width="88px">
                    <col v-for="n in 12" :key="n">
                </colgroup>
                <thead>
                <tr>
                    <th class="table-col__head" rowspan="2">구분</th>
                    <th class="table-col__head" colspan="12">
                      <em> {{item.year}}년 </em>
                    </th>
                </tr>
                <tr>
                    <th class="table-col__head" v-for="(retention) in item.retentionDetail":key="retention.index">{{retention.month}}월</th>
                </tr>
                </thead>

                <tbody>
                    <tr>
                        <td class="table-col__data">진행</td>
                        <td class="table-col__data" v-for="(retention) in item.retentionDetail" :key="retention.index">{{retention.progress}}</td>
                    </tr>
                    <tr>
                        <td class="table-col__data">달성</td>
                        <td class="table-col__data" v-for="(retention) in item.retentionDetail" :key="retention.index">{{retention.completed}}</td>
                    </tr>
                    <tr>
                        <td class="table-col__data">반품</td>
                        <td class="table-col__data" v-for="(retention) in item.retentionDetail" :key="retention.index">{{retention.returnProduct}}</td>
                    </tr>
                    <tr>
                        <td class="table-col__data">회수</td>
                        <td class="table-col__data" v-for="(retention) in item.retentionDetail" :key="retention.index">{{retention.returnGift}}</td>
                    </tr>
                </tbody>
            </table>

            <table class="rew19-table-col mb">
                <caption>콜 테이블</caption>
                <colgroup>
                    <col width="36%">
                    <col width="16%">
                    <col width="16%">
                    <col width="16%">
                    <col width="16%">
                </colgroup>
                <thead>
                    <tr>
                        <th class="table-col__head">
                            {{item.year}}년
                        </th>
                        <th class="table-col__head">진행</th>
                        <th class="table-col__head">달성</th>
                        <th class="table-col__head">반품</th>
                        <th class="table-col__head">회수</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(retention) in item.retentionDetail" :key="retention.index">
                      <td class="table-col__data">{{retention.month}}월</td>
                      <td class="table-col__data">{{retention.progress}}</td>
                      <td class="table-col__data">{{retention.completed}}</td>
                      <td class="table-col__data">{{retention.returnProduct}}</td>
                      <td class="table-col__data">{{retention.returnGift}}</td>
                    </tr>
                </tbody>
            </table>
            </swiper-slide>

            <div class="swiper-tbl-next" slot="button-next"></div>
            <div class="swiper-tbl-prev" slot="button-prev"></div>

        </swiper>
      </div>
      <!--//rew19_twoTable_wrap-->

       <!-- 4+1 리스트가 없는 경우 -->
      <div class="rew19_order_box noList" v-if="viewData.retentionList <= 0">
            <p class="flex">4+1 정기구매 진행내역이 없습니다.</p>
      </div>
    </div>
    <!--rew19_contents_inner-->
  </div>
</template>
<script>
import AroBase from "@/components/base/AroBase";
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import PageNav from "@/components/paging/pageNav";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import DF from 'dateformat';

export default {
  name: "fourPlusDetail",
  extends: AroBase,
  components: { swiper, swiperSlide },
  data: () => ({
    //View Data
    viewData: {},
    testText: "",
    swiperOption: {
        slidesPerView: 'auto',
	      //loop: true,
        navigation: {
          nextEl: '.swiper-tbl-next',
          prevEl: '.swiper-tbl-prev'
        },
        observer: true,
        observeParents: true
      },
  }),
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created() {},
  mounted() {
    let _this = this;

    _this.year = DF(new Date(), 'yyyy');

    _this.loadData();
  },

  methods: {
    /**
     * API Request
     */

    // 리텐션 프로그램 자세히 보기
    apiGetRetentions(rType) {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/retentions`, {
        params: {
          rType: rType
        }
      });
    },

    //데이터 로드
    loadData() {
      let _this = this;

      //show loading
      _this.$showLoading();
      _this
        .apiGetRetentions(2)
        .then(res => {
          
          if (res.status === 200 && res.data.status === "0000") {
            _this.viewData = { ...res.data };
          } else {
            //console.error(res);
            _this.$dialogs.alert(res.data.message).then(res => {});
          }
        }).catch(err => {
          console.error(err);
          _this.$dialogs
            .alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {
              title: ErrMsg.COMM_ERROR_TITLE
            })
            .then(res => {});
        }).finally(() => {
          /* if (_this.retentionList.length > 0) {
             let initSlideIdx = _this.retentionDetail.yearList.length - 1;
             _this.swiperOption.slidesPerView = initSlideIdx;
          } */
          //hide loading
          _this.$hideLoading();
        });
    },

    slideChange(a,b,c,d){
    },

  }
};
</script>
<style>
.four_plus_swiper .swiper-button-next{
    background: url(https://resource2018.nuskinkorea.co.kr/images/aro/btn_tbl_next.png) no-repeat;
    display: block;
    position: absolute;
    top: 34px;
    right: 430px;
    width: 20px;
    height: 20px;
}
.four_plus_swiper .swiper-button-prev{
    background: url(https://resource2018.nuskinkorea.co.kr/images/aro/btn_tbl_prev.png) no-repeat;
    display: block;
    position: absolute;
    top: 34px;
    left: 520px;
    width: 20px;
    height: 20px;
}

@media only screen and (max-width: 768px) {
.four_plus_swiper .swiper-button-next{
  right: 324px;
}
.four_plus_swiper .swiper-button-prev{
  left: 14px;
}
}

.four_plus_wrap .rew19_twoTable_wrap{
  border-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/my/aro/fourPlusDetail.vue